import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/modules/auth/stores/authStore';

export default function SplashPage() {
  const navigate = useNavigate();
  const { isAuthenticated, initialize } = useAuthStore();

  useEffect(() => {
    // 초기화 후 리다이렉트
    initialize();
    
    const timer = setTimeout(() => {
      if (isAuthenticated) {
        navigate('/lobby', { replace: true });
      } else {
        navigate('/login', { replace: true });
      }
    }, 1500);

    return () => clearTimeout(timer);
  }, [isAuthenticated, navigate, initialize]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-900">
      {/* Logo Animation */}
      <div className="animate-pulse-slow">
        <span className="text-6xl">🎙️</span>
      </div>
      
      <h1 className="text-2xl font-bold text-primary-400 mt-6">
        Debate Battle
      </h1>
      
      <p className="text-slate-400 mt-2">실시간 음성 토론 배틀</p>

      {/* Loading Indicator */}
      <div className="mt-8">
        <div className="w-8 h-8 border-4 border-primary-500 border-t-transparent rounded-full animate-spin" />
      </div>
    </div>
  );
}
